import React from 'react'
import { Wrapper } from '@googlemaps/react-wrapper'
import { Modal } from './VehicleMapModal.styled'
import MapWrapper from '../map-wrapper/MapWrapperContainer'

export interface IOwnProps {
  open: boolean
  onClose: () => void
  header: () => React.ReactNode,
}

export interface IStateProps {}

export interface IDispatchProps { }

export type IProps = IOwnProps & IStateProps & IDispatchProps

const VehicleMapModal: React.FC<IProps> = (props) => {
  const {
    open,
    onClose,
    header,
  } = props

  return (
    <Modal
      modalName='vehicleMap'
      open={open}
      onClose={onClose}
      header={header}
      isWideContent
    >
      <Wrapper apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY || ''}>
        <MapWrapper/>
      </Wrapper>
    </Modal>
  )
}

export default VehicleMapModal
